import Guard from 'arg-guard'

/**
 * Defined structure of scheme data from the services.
 *
 * @export SchemeDataSummary
 * @class SchemeDataSummary
 */
export default class SchemeDataSummary {

    /**
     * Creates an instance of a Scheme Data Summary.
     * @param {Object} data Source data - From API or state.
     * @memberof SchemeDataSummary
     */
    constructor(data) {
        Guard.throwIf(data, 'data')

        this.id = data.id
        this.name = data.name
        this.assetFolderName = data.assetFolderName
        this.uriRoot = data.uriRoot
    }

    /**
     * Ensures that the provided data is already of this type. If not, it runs the constructor.
     *
     * @static
     * @param {Object} data Source data.
     * @returns {SchemeDataSummary} Either the data is passed back if already of this type or the result of the constructor is.
     * @memberof SchemeDataSummary
     */
    static ensure(data) {
        return data && data instanceof SchemeDataSummary ? data : new SchemeDataSummary(data)
    }
}
